import React from "react";

export interface BehaviorFontContextValue {
  /** User-uploaded font families (same list as the display property panel). */
  customFontFamilies: string[];
  /** Opens the font file picker and returns the uploaded family name. */
  onPickFont?: () => Promise<string | null>;
}

const defaultValue: BehaviorFontContextValue = {
  customFontFamilies: [],
};

export const BehaviorFontContext =
  React.createContext<BehaviorFontContextValue>(defaultValue);
